import Image from "./Image";

export interface StudioCardProps {
  name: string;
  subtitle?: string;
  coverImg: string;
  brief: string;
  servicesProvided: string[];
  className?: string;
}

const StudioCard = ({
  name,
  coverImg,
  brief,
  subtitle,
  servicesProvided,
  className,
}: StudioCardProps) => {
  return (
    <div
      className={`flex flex-col items-center w-full h-full justify-center text-white relative border-white border-b-1 col-span-4 md:col-span-3 xl:col-span-4 overflow-hidden ${className}`}
    >
      <Image
        className="w-full h-full object-cover max-h-72"
        height={740}
        width={789}
        src={coverImg}
        alt={name + "logo"}
      />
      <div className="relative w-full flex-1 max-w-full">
        <div className="min-w-full h-full flex flex-col pt-4 overflow-hidden">
          <div className="flex flex-col gap-2">
            <h5 className="font-semibold font-xExpandedBold text-lg md:text-base lg:text-xl 3xl:text-2xl overflow-hidden">
              {name}
            </h5>
            <h6 className="font-condensedItalic text-lg md:text-base lg:text-sm 3xl:text-base">
              {subtitle}
            </h6>
            <p className="font-light text-sm md:text-base lg:text-base 3xl:text-lg pt-2">{brief}</p>
          </div>
          <div className="flex-1 gap-2 flex justify-end pt-4">
            {servicesProvided.map((service) => (
              <p
                className={`bg-cultiv-red px-2.5 h-6 text-white font-condensedItalic flex justify-center items-center self-end text-xs 3xl:text-base capitalize`}
                key={service}
              >
                {service}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudioCard;
